export const ORGANIZATION_AI_MODELS_KEY = ["organizationAiModels"];
